import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Image, Row } from 'react-bootstrap'
import {
  createSearchParams,
  useNavigate,
  useSearchParams
} from 'react-router-dom'
import { Checkbox } from 'antd'
import StapMainLayout from './step-main'
import {
  EMP_CHECK_LIST_DETAIL_ST_3,
  EMP_CHECK_LIST_DETAIL_ST_5
} from '../../../../router/routes'
import { BsChevronDoubleLeft, BsChevronDoubleRight } from 'react-icons/bs'
import styled from 'styled-components'
import ImgCheckbox from '../../../../images/checkbox.svg'
import {
  getChecklistNewStepDetailAPI,
  postChecklistNewThreeSupAPI,
  putChecklistNewThreeAPI
} from '../../../../services/checklist'
import Error_500 from '../../../error/error-500'
import SwalCustom from '../../../../alert/swal-custom'
import { TXTSUCCESS } from '../../../../Constants'
import Error_false from '../../../error/error-false'
import moment from 'moment'
import StapPage4To1 from './step-4-1'
import StapPage4To2 from './step-4-2'
import StapPage5To2 from './step-4-5(2)'
import SwalCustomSuccess from '../../../../alert/swal-success'

export default function StapPage3() {
  let [searchParams, setSearchParams] = useSearchParams()
  const org = searchParams.get('org')
  const code = searchParams.get('code')
  const clnNo = searchParams.get('id')
  const status = searchParams.get('status')
  const [detail_1, setDetail_1] = useState([])
  const [isSubmit, setIsSubmit] = useState(false)
  const [approve, setApprove] = useState()
  const [approveSup, setApproveSup] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [dataStep1, setDataStep1] = useState()
  const [dataStep2, setDataStep2] = useState()
  const [dataStep5, setDataStep5] = useState()

  //ปฐมนิเทศ
  const handleCheckboxBuilding = (event, id) => {
    const { value, checked } = event.target
    if (checked) {
      setDetail_1((prev) => {
        const newData = prev.filter((item) => item.id === id)
        return [
          ...[
            {
              ...newData[0],
              is_check: 1,
              detail: ''
            }
          ],
          ...prev.filter((item) => item.id !== id)
        ]
      })
    } else {
      setDetail_1((prev) => {
        const newData = prev.filter((item) => item.id === id)
        return [
          ...[
            {
              ...newData[0],
              is_check: 0,
              detail: ''
            }
          ],
          ...prev.filter((item) => item.id !== id)
        ]
      })
    }
  }

  const [dataStep, setDataStep] = useState([])
  const [isComputer, setIsComputer] = useState(0)
  const [createDate, setCreateDate] = useState([])

  useEffect(() => {
    getStep()
    return () => {}
  }, [])
  const getStep = async (stepId = 3) => {
    try {
      setIsLoading(true)
      const resp = await getChecklistNewStepDetailAPI({
        stepId,
        clnNo
      })
      setIsLoading(false)

      if (!resp) return
      if (resp.status) {
        setCreateDate(resp.result.insert_date)

        setDataStep1(resp.result.step1)
        setDataStep2(resp.result.step2)
        setDataStep5(resp.result.step5)

        setIsComputer(resp.result.is_computer ? 1 : 0)
        setApprove(resp.result.approve)
        setDataStep(resp.result.result)
        setApproveSup(resp.result.approve_it_sup)
        setDetail_1(
          resp.result.result.length > 0 ? resp.result.result[0].groups : []
        )
      } else {
        setDataStep1()
        setDataStep2()
        setDataStep5()

        setDataStep([])
      }
    } catch (error) {
      Error_500(error)
    }
  }
  const nevigate = useNavigate()
  const fnBack = () => {
    nevigate(
      {
        pathname: EMP_CHECK_LIST_DETAIL_ST_3,
        search: `?${createSearchParams({
          code,
          org,
          id: clnNo,
          status: status
        })}`
      },
      { replace: true }
    )
  }
  const fnNext = () => {
    nevigate(
      {
        pathname: EMP_CHECK_LIST_DETAIL_ST_5,
        search: `?${createSearchParams({
          code,
          org,
          id: clnNo,
          createDate: createDate,
          status: status
        })}`
      },
      { replace: true }
    )
  }

  const fnConfirm = () => {
    const detailCheck = detail_1.filter((d) => d.is_check === 1)
    const body = {
      equipId: dataStep[0].equip_it_group_id,
      equips: detailCheck.map((d) => {
        return { id: d.id, detail: d.detail }
      })
    }
    SwalCustom({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: '#2C5DFE',
      confirmButtonText: 'Submit'
    }).then((result) => {
      if (result.isConfirmed) {
        setIsSubmit(true)
        fnSave(body)
      }
    })
  }
  const fnSave = async (body) => {
    try {
      setIsLoading(true)
      const param = { clnNo }
      const resp = await putChecklistNewThreeAPI(param, body)
      setIsSubmit(false)
      setIsLoading(false)
      if (!resp) return
      if (resp.status) {
        SwalCustomSuccess().then(() => {
          getStep()
        })
      } else {
        Error_false(resp)
      }
    } catch (error) {
      Error_500(error)
    }
  }

  const fnSave2 = async () => {
    try {
      setIsLoading(true)
      const param = { clnNo }
      const resp = await postChecklistNewThreeSupAPI(param)
      setIsSubmit(false)
      setIsLoading(false)
      if (!resp) return
      if (resp.status) {
        SwalCustomSuccess().then(() => {
          getStep()
        })
      } else {
        Error_false(resp)
      }
    } catch (error) {
      Error_500(error)
    }
  }
  return (
    <Row>
      {isLoading && <div className="preloader"></div>}

      <Col
        xl={12}
        className="mt-3 mb-3"
        style={{ position: 'sticky', top: 0, zIndex: 1000 }}
      >
        <StapMainLayout current={3} />
      </Col>
      <Col xl={12}>
        <StapPage4To1 step={dataStep1} createDate={createDate} />
        <div className="pt-5 ">
          <p style={{ borderTop: '1px dashed rgb(135, 135, 135)' }}></p>
        </div>

        <StapPage5To2 step={dataStep5} createDate={createDate} />
        <div className="pt-5 ">
          <p style={{ borderTop: '1px dashed rgb(135, 135, 135)' }}></p>
        </div>
        <StapPage4To2
          step={dataStep2}
          isComputer={isComputer}
          createDates={createDate}
        />
        <div className="fw-bold mb-2 ">
          {dataStep.length > 0 && dataStep[0].equip_it_group}
        </div>

        <Checkbox.Group>
          <CheckboxCustom className="fw-light">
            {detail_1.length > 0 &&
              detail_1
                .sort((a, b) => a.id - b.id)
                .map((d, i) => (
                  <Form.Check
                    key={i}
                    value={d.id}
                    checked={d.is_check === 1 ? true : false}
                    label={d.equip_it_name}
                    name={`description`}
                    type="checkbox"
                    className="mb-3"
                    onChange={(e) => handleCheckboxBuilding(e, d.id)}
                  />
                ))}
          </CheckboxCustom>
        </Checkbox.Group>
      </Col>
      {approve ? (
        <Col xl={12}>
          <Row>
            <Col className="d-flex align-self-end justify-content-center">
              <div className=" mt-5 font-small-2 d-flex justify-content-center">
                <div style={{ width: 300 }}>
                  <div className="d-flex justify-content-center">
                    <Image width={250} fluid src={approve.url} />
                  </div>
                  <div className="d-flex justify-content-center">
                    ลงชื่อ
                    <div
                      style={{
                        borderBottom: '1px dashed rgb(135, 135, 135)',
                        width: 200
                      }}
                    ></div>{' '}
                    ผู้ดำเนินการ
                  </div>
                  <div className="d-flex justify-content-center mt-3">
                    ({approve.title_th} {approve.name_th} {approve.surname_th})
                  </div>
                  <div className="d-flex justify-content-center fw-light mt-1">
                    {approve.position_th}
                  </div>
                  <div className="d-flex justify-content-center fw-light">
                    {moment(approve.confirm_date3).format('DD/MM/YYYY')}
                  </div>
                </div>
              </div>
            </Col>
            <Col className="d-flex align-self-end justify-content-center">
              <div className=" mt-5 font-small-2 d-flex justify-content-center">
                <div style={{ width: 300 }}>
                  <div className="d-flex justify-content-center">
                    {approveSup && approveSup.confirm_date3_2 !== null ? (
                      <Image width={250} fluid src={approveSup.url} />
                    ) : (
                      <Button
                        className="px-4 mt-5"
                        disabled={isSubmit}
                        onClick={() => {
                          fnSave2()
                        }}
                      >
                        {isSubmit ? 'Submiting...' : 'Submit'}
                      </Button>
                    )}
                  </div>
                  <div className="d-flex justify-content-center">
                    ลงชื่อ
                    <div
                      style={{
                        borderBottom: '1px dashed rgb(135, 135, 135)',
                        width: 200
                      }}
                    ></div>{' '}
                    ผู้ตรวจสอบ
                  </div>
                  <div className="d-flex justify-content-center mt-3">
                    (
                    {approveSup &&
                      `${approveSup.title_th}${approveSup.name_th} ${approveSup.surname_th}`}
                    )
                  </div>
                  <div className="d-flex justify-content-center fw-light mt-1">
                    {approveSup && approveSup.position_th}
                  </div>
                  <div className="d-flex justify-content-center fw-light">
                    {approveSup && approveSup.confirm_date3_2
                      ? moment(approveSup.confirm_date3_2).format('DD/MM/YYYY')
                      : '-'}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      ) : (
        <Col xl={12} className="mt-5 text-center">
          <Button
            disabled={isSubmit}
            className="px-5 rounded-3"
            onClick={fnConfirm}
          >
            {isSubmit ? 'Submiting...' : 'Submit'}
          </Button>
        </Col>
      )}

      <div
        className="d-flex justify-content-between  bg-white"
        style={{ position: 'sticky', bottom: 0, zIndex: 1000 }}
      >
        <span className="p-3 border-0 small pointer-event" onClick={fnBack}>
          <BsChevronDoubleLeft className="me-2 " />
          Back
        </span>
        {approve && (
          <span className="p-3 border-0 small pointer-event" onClick={fnNext}>
            Next
            <BsChevronDoubleRight className="ms-2 " />
          </span>
        )}
      </div>
    </Row>
  )
}

const CheckboxCustom = styled.div`
  .form-check-inline {
    display: inline-block;
    margin-right: 3px;
  }

  .form-check-input[type='radio'] {
    margin-top: auto !important;
    margin-bottom: auto !important;
    border-radius: 4px;
    background-image: url(${ImgCheckbox}) !important;
  }
  .form-check-input:checked {
    background-color: 'var(--comp-badge-color-background-primary)' !important;
  }
  .form-check-input {
    width: 1.5em;
    height: 1.5em;
    border: 1px solid 'var(--comp-badge-color-background-primary)';
  }
  label {
    margin: 0em 0em 0em 1em;
  }
  .form-check .form-check-input {
    float: left;
    margin-left: 0em;
    margin-top: 0em;
  }
`
